$(document).ready(function () {
  (function () {
    const sameDayDeliveryCollection = "same-day";


    function formatDisplayDate(dateObj) {
  if (!dateObj) return "";
  return dateObj.toLocaleDateString("en-GB", { day: "2-digit", month: "short" });
}

function formatHiddenDate(dateObj) {
  return $.datepicker.formatDate("dd-mm-yy", dateObj);
}

    function getShopTodayDate() {
      if (typeof shopToday === "string") {
        const parts = shopToday.split("-");
        if (parts.length === 3) {
          return new Date(
            Number(parts[0]),
            Number(parts[1]) - 1,
            Number(parts[2])
          );
        }
      }
      const now = new Date();
      return new Date(now.getFullYear(), now.getMonth(), now.getDate());
    }

    function getShopNowHour() {
      if (typeof shopNowHour === "number") return shopNowHour;
      if (typeof shopNowHour === "string") {
        const parsed = parseInt(shopNowHour, 10);
        if (!isNaN(parsed)) return parsed;
      }
      return new Date().getHours();
    }

    function formatDate(date) {
      const day = ("0" + date.getDate()).slice(-2);
      const month = ("0" + (date.getMonth() + 1)).slice(-2);
      const year = date.getFullYear().toString().slice(-2);
      return `${day}-${month}-${year}`; // dd-mm-yy
    }

    function parseFormattedDate(ddmmyy) {
      const parts = (ddmmyy || "").split("-");
      if (parts.length !== 3) return null;
      const dd = parseInt(parts[0], 10);
      const mm = parseInt(parts[1], 10);
      const yy = parseInt(parts[2], 10);
      if (!dd || !mm || isNaN(yy)) return null;
      return new Date(2000 + yy, mm - 1, dd);
    }

    function isUnavailableDate(date) {
      const formatted = formatDate(date);
      return Array.isArray(unavailableDates) && unavailableDates.includes(formatted);
    }

    function isSameDayAfterCutoff(date) {
      if (typeof deliveryCutoffHour !== "number") return false;

      const today = getShopTodayDate();
      if (formatDate(date) === formatDate(today)) {
        return getShopNowHour() >= deliveryCutoffHour;
      }
      return false;
    }

    // Mirrors the datepicker rule
    function isSelectable(date) {
      return !isSameDayAfterCutoff(date) && !isUnavailableDate(date);
    }

    function getFirstAvailableDateFrom(baseDate) {
      const d = new Date(baseDate.getTime());
      while (!isSelectable(d)) d.setDate(d.getDate() + 1);
      return d;
    }

    // Determine if same-day is allowed (collection + cutoff) RIGHT NOW
    function computeMinDateOffsetNow() {
      let offset = 1; // default tomorrow
      if (
        Array.isArray(productCollections) &&
        productCollections.includes(sameDayDeliveryCollection)
      ) {
        if (getShopNowHour() < deliveryCutoffHour) offset = 0;
      }
      return offset;
    }

    function getTodayDateOnly() {
      return getShopTodayDate();
    }

    function getTomorrowDateOnly() {
      const t = getTodayDateOnly();
      return new Date(t.getFullYear(), t.getMonth(), t.getDate() + 1);
    }

    // ---- Init EACH delivery block (safe even if multiple exist) ----
    $(".delivery-date-block").each(function () {
      const $block = $(this);

      // Buttons
      const $btnToday = $block.find('[data-choice="today"]');
      const $btnTomorrow = $block.find('[data-choice="tomorrow"]');
      const $btnPick = $block.find('[data-choice="pick"]');

      // Inputs/text (support both your IDs and your classes)
      const $firstAvail = $block
        .find("#first_available_date, .first_available_date")
        .first();
      const $hidden = $block
        .find("#hidden_delivery_date, .hidden_delivery_date")
        .first();
      const $selected = $block
        .find("#selected_delivery_date, .selected_delivery_date")
        .first();

      // IMPORTANT: in your current LIQUID this is a DIV calendar container
      const $calendar = $block.find("#delivery_date_picker, .delivery_date_picker").first();

      // Overlay
      const $overlay = $block.find(".delivery-overlay").first();
      const $overlayClose = $block.find("[data-delivery-close]");

      function setActive($btn) {
        $block.find(".delivery-btn").removeClass("is-active");
        $btn.addClass("is-active");
      }

      function updatePickButtonLabel(dateText) {
        if (!dateText) $btnPick.text("Pick a date");
        else $btnPick.text("Delivery: " + dateText);
      }

      function setDeliveryDate(dateObj) {
  const hidden = formatHiddenDate(dateObj);
  const display = formatDisplayDate(dateObj);

  $hidden.val(hidden);
  $selected.text("Selected Delivery Date: " + display);
  updatePickButtonLabel(display);
}


      function openOverlay() {
        if (!$overlay.length) return;
        $overlay.removeAttr("hidden").attr("aria-hidden", "false");
      }

      function closeOverlay() {
        if (!$overlay.length) return;
        $overlay.attr("hidden", true).attr("aria-hidden", "true");
      }

      // Close on backdrop / X / Done
      $overlayClose.off("click.delivery").on("click.delivery", closeOverlay);

      // Close on ESC
      $(document).off("keydown.delivery").on("keydown.delivery", function (e) {
        if (e.key === "Escape" && $overlay.length && !$overlay.is("[hidden]")) {
          closeOverlay();
        }
      });

      // Refresh rules + compute first available
      function refreshRules() {
        const minDateOffset = computeMinDateOffsetNow();
        const today = getTodayDateOnly();

        const todayAllowed = minDateOffset === 0 && isSelectable(today);

        if (!todayAllowed) {
          $btnToday.prop("disabled", true).css({ opacity: 0.45, cursor: "not-allowed" });
        } else {
          $btnToday.prop("disabled", false).css({ opacity: "", cursor: "" });
        }

        const start = new Date(today);
        start.setDate(start.getDate() + minDateOffset);
        const firstAvailableDate = getFirstAvailableDateFrom(start);

        if ($firstAvail.length) $firstAvail.val(formatDate(firstAvailableDate));

        return { todayAllowed, today, firstAvailableDate };
      }

      // Initial compute
      const init = refreshRules();
      const today = init.today;
      const tomorrow = getTomorrowDateOnly();
      const tomorrowPick = getFirstAvailableDateFrom(tomorrow);
      const firstAvailableDate = init.firstAvailableDate;

      // --- Init DATEPICKER as INLINE CALENDAR on a DIV ---
      // Destroy if already initialized (prevents double init)
      try {
        if ($calendar.hasClass("hasDatepicker")) $calendar.datepicker("destroy");
      } catch (e) {}

      $calendar.datepicker({
        dateFormat: "dd-mm-yy",
        minDate: firstAvailableDate,
        beforeShowDay: function (date) {
          if (date < firstAvailableDate) return [false];
          return [isSelectable(date)];
        },
        onSelect: function (dateText) {
  const dateObj = $(this).datepicker("getDate");

  $hidden.val(dateText); // stays dd-mm-yy
  const displayText = formatDisplayDate(dateObj);

  $selected.text("Selected Delivery Date: " + displayText);
  updatePickButtonLabel(displayText);
  closeOverlay();
}

      });

      // Set default selection to firstAvailableDate
      $calendar.datepicker("setDate", firstAvailableDate);
      const defaultHidden = formatHiddenDate(firstAvailableDate);   // dd-mm-yy
const defaultDisplay = formatDisplayDate(firstAvailableDate); // 20 Jan

$hidden.val(defaultHidden);
$selected.text("Selected Delivery Date: " + defaultDisplay);
updatePickButtonLabel(defaultDisplay);


      // Default active button state
      if (init.todayAllowed && formatDate(firstAvailableDate) === formatDate(today)) {
        setActive($btnToday);
      } else if (formatDate(firstAvailableDate) === formatDate(tomorrowPick)) {
        setActive($btnTomorrow);
      } else {
        setActive($btnPick);
      }

      // ---- Button handlers ----
      $btnToday.off("click.delivery").on("click.delivery", function () {
        const state = refreshRules();
        if (!state.todayAllowed) return;

        setActive($btnToday);
        setDeliveryDate(state.today);
        // Sync calendar selection too
        $calendar.datepicker("setDate", state.today);
      });

      $btnTomorrow.off("click.delivery").on("click.delivery", function () {
        const tp = getFirstAvailableDateFrom(getTomorrowDateOnly());
        setActive($btnTomorrow);
        setDeliveryDate(tp);
        $calendar.datepicker("setDate", tp);
      });

      $btnPick.off("click.delivery").on("click.delivery", function () {
        // Recompute firstAvailableDate at click time (cutoff might pass)
        const state = refreshRules();
        setActive($btnPick);

        // Update datepicker minDate live
        try {
          $calendar.datepicker("option", "minDate", state.firstAvailableDate);
        } catch (e) {}

        // Ensure current selection isn't before minDate
        const current = $hidden.val();
        const parsed = parseFormattedDate(current);
        if (!parsed || parsed < state.firstAvailableDate) {
          $calendar.datepicker("setDate", state.firstAvailableDate);
          const txt = $.datepicker.formatDate("dd-mm-yy", state.firstAvailableDate);
          $hidden.val(txt);
          $selected.text("Selected Delivery Date: " + txt);
          updatePickButtonLabel(txt);
        }

        openOverlay();
      });

      // Keep Today disabling after cutoff even if page stays open
      setInterval(refreshRules, 30 * 1000);

      // Add-to-cart injection (scoped)
      const $form = $block.closest('form[action="/cart/add"], form[action*="/cart/add"]');
      const $forms = $form.length ? $form : $('form[action="/cart/add"], form[action*="/cart/add"]');

      $forms.off("submit.deliverydate").on("submit.deliverydate", function (event) {
        event.preventDefault();

        const deliveryDate = $hidden.val();
        if (!deliveryDate) return;

        $(this).find('input[name="properties[Delivery Date]"]').remove();
        $(this).append(
          '<input type="hidden" name="properties[Delivery Date]" value="' + deliveryDate + '">'
        );

        $(this).off("submit.deliverydate");
        this.submit();
      });
    });
  })();
});
